define([], ()=> {
    return ['$q', 'JsonRPCService', ($q, JsonRPCService)=> {
        return {
            accountLookupBasedOnDob: (callGroups, accountLookupRequestDTO)=> {
                const deferred = $q.defer();
                JsonRPCService.send('accountlookup', 'accountlookup', 'isAccountAvailable', [accountLookupRequestDTO], callGroups).then(
                    (accountLookupResponseDTO)=> {
                        return deferred.resolve(accountLookupResponseDTO);
                    }, (error, status, headers)=> {
                        return deferred.reject([error, status, headers]);
                    });
                return deferred.promise;
            }
        };
    }];
});


/** WEBPACK FOOTER **
 ** ./app/customer/js/src/edge/policyjob/services/AccountLookupService.js
 **/